import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User } from 'api/models';
import { Strong, Value } from '../../basics';
import { Causer } from '../causer';

interface Props {
  by: User;
  item?: JSX.Element | null;
  name: string;
  prefix?: string;
  from: JSX.Element | null;
  to: JSX.Element | null;
}

const Arrow = styled(ArrowRight16)`
  color: var(--coolest-gray-90);
  flex-shrink: 0;
`;

const getId = (from: any | null, to: any | null) => {
  if (!!from && !!to) {
    return 'field_changed';
  }

  return from ? 'field_reset' : 'field_set';
};

const Prefix = styled(Value)`
  margin-right: 0;
`;

export const FieldChangedMessage: FC<Props> = ({
  by,
  name,
  item,
  prefix,
  from,
  to,
}) => {
  return (
    <FormattedMessage
      id={`notifications.messages.${item != null ? 'item_' : ''}${getId(
        from,
        to,
      )}`}
      values={{
        causer: <Causer user={by} />,
        arrow: <Arrow />,
        name: (
          <>
            {prefix == null ? null : <Prefix>{prefix}</Prefix>}
            <Strong>{name}</Strong>
          </>
        ),
        item,
        from: <Value>{from}</Value>,
        to: <Value>{to}</Value>,
      }}
    />
  );
};
